// Parse markdown prompt format into prompt object

export const parsePromptMarkdown = (markdown) => {
  const errors = [];
  const lines = markdown.split('\n');

  if (!lines || lines.length === 0) {
    throw new Error("Markdown is empty");
  }

  const prompts = [];
  let currentPrompt = null;
  let readingContent = false;

  console.log("📝 Parsing prompt markdown with", lines.length, "lines");

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    console.log(`Line ${i}: "${trimmed.substring(0, 60)}${trimmed.length > 60 ? '...' : ''}"`);

    // Skip empty lines unless we're reading content
    if (!trimmed) {
      if (readingContent && currentPrompt) {
        currentPrompt.text += "\n";
      }
      continue;
    }

    // New prompt starts with **title**
    if (trimmed.startsWith("**") && trimmed.endsWith("**") && !trimmed.includes("Category") && !trimmed.includes("Prompt content")) {
      if (currentPrompt && currentPrompt.title && currentPrompt.cat && currentPrompt.text.trim()) {
        prompts.push(currentPrompt);
        console.log(`✓ Saved prompt: "${currentPrompt.title}"`);
      }

      const title = trimmed.replace(/\*\*/g, "").trim();
      currentPrompt = {
        id: "cp_" + Date.now(),
        title: title,
        cat: "",
        text: "",
        addedAt: new Date().toISOString()
      };
      readingContent = false;
      console.log(`→ New prompt: "${title}"`);
      continue;
    }

    // Category line
    if (trimmed.startsWith("Category:") && currentPrompt) {
      const category = trimmed.replace("Category:", "").trim();
      currentPrompt.cat = category;
      readingContent = false;
      console.log(`  Category: "${category}"`);
      continue;
    }

    // Prompt content line (start reading content)
    if (trimmed.startsWith("Prompt content:") && currentPrompt) {
      const contentStart = trimmed.replace("Prompt content:", "").trim();
      currentPrompt.text = contentStart;
      readingContent = true;
      console.log(`  Content: "${contentStart.substring(0, 50)}..."`);
      continue;
    }

    // Continuation of prompt content (multi-line support)
    if (readingContent && currentPrompt) {
      // Check if this is a new section (next prompt or new field)
      if (trimmed.startsWith("**") || trimmed.startsWith("Category:") || trimmed.startsWith("Prompt content:")) {
        // This is a new section, don't add to content
        i--;  // Back up one line to re-process it
        readingContent = false;
      } else {
        // Add to current prompt content
        if (currentPrompt.text) {
          currentPrompt.text += "\n" + trimmed;
        } else {
          currentPrompt.text = trimmed;
        }
      }
    }
  }

  // Save last prompt if exists
  if (currentPrompt && currentPrompt.title && currentPrompt.cat && currentPrompt.text.trim()) {
    prompts.push(currentPrompt);
    console.log(`✓ Saved final prompt: "${currentPrompt.title}"`);
  }

  // Validation
  if (prompts.length === 0) {
    errors.push("At least one prompt is required");
  }

  prompts.forEach((p, idx) => {
    if (!p.title) {
      errors.push(`Prompt ${idx + 1}: title is required`);
    }
    if (!p.cat) {
      errors.push(`Prompt ${idx + 1}: category is required`);
    }
    if (!p.text || !p.text.trim()) {
      errors.push(`Prompt ${idx + 1}: content is required`);
    }
  });

  console.log(`\n📊 Parsing complete: ${prompts.length} prompts, ${errors.length} errors`);

  if (errors.length > 0) {
    throw new Error(`Markdown parsing errors:\n${errors.join("\n")}`);
  }

  return prompts;
};
